<template>
  <div>
    <div v-show="isEditing">
      <div class="title">
        <i class="iconfont icon-back" @click="goback()"></i>
        <img src="/static/logo.png" />
        <div>留言板</div>
      </div>
      <div class="weui-cells weui-cells_form" style="margin-top: 0px">
        <div class="weui-cell" v-if="editMotto">
          <div class="weui-cell__bd">
            <textarea
              class="weui-textarea"
              v-model="circle.motto"
              maxlength="100"
              placeholder="请输入您的座右铭"
              rows="2"
            ></textarea>
            <div
              class="weui-textarea-counter"
              :class="{
                'text-error': circle.motto && circle.motto.length > 100,
              }"
            >
              <span>{{ circle.motto ? circle.motto.length : 0 }}</span
              >/100
            </div>
          </div>
        </div>
        <div class="weui-cell" v-else>
          <span class="motto" @click="edit"
            >座右铭 <i class="iconfont icon-bianji"></i></span
          >{{ circle.motto }}
        </div>
        <div class="weui-cell">
          <div class="weui-cell__bd">
            <textarea
              class="weui-textarea"
              v-model="circle.word"
              maxlength="200"
              placeholder="人过留名，雁过留声"
              rows="4"
            ></textarea>
            <div
              class="weui-textarea-counter"
              :class="{ 'text-error': circle.word && circle.word.length > 200 }"
            >
              <span>{{ circle.word ? circle.word.length : 0 }}</span
              >/200
            </div>
          </div>
        </div>
        <div class="weui-cell" id="uploader">
          <div class="weui-cell__bd">
            <div class="weui-uploader">
              <div class="weui-uploader__hd">
                <p class="weui-uploader__title">
                  配图
                  <span style="color: red; font-size: 12px"
                    >（选填，不超过4M）</span
                  >
                </p>
                <div class="weui-uploader__info">
                  <span>{{ uploadCount }}</span
                  >/9
                </div>
              </div>
              <div class="weui-uploader__bd">
                <ul class="weui-uploader__files" id="uploaderFiles"></ul>
                <div class="weui-uploader__input-box">
                  <input
                    id="uploaderInput"
                    class="weui-uploader__input"
                    type="file"
                    accept="image/*"
                    multiple
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="warehousing-footer-item" style="flex: 1" @click="save">
        <a href="javascript:;">提 交</a>
      </div>
    </div>
    <div v-show="!isEditing">
      <div class="page">
        <div class="weui-msg">
          <div class="weui-msg__icon-area">
            <i class="weui-icon-success weui-icon_msg"></i>
          </div>
          <div class="weui-msg__text-area">
            <h2 class="weui-msg__title">留言成功</h2>
            <p class="weui-msg__desc">人过留名，雁过留声~ヾ(≧O≦)〃嗷~</p>
          </div>
          <div class="weui-msg__opr-area">
            <p class="weui-btn-area">
              <a
                href="javascript:;"
                class="weui-btn weui-btn_blue"
                @click="index"
                >到首页查看</a
              >
            </p>
          </div>
          <div class="weui-msg__extra-area">
            <div class="weui-footer">
              <p class="weui-footer__links">
                <a href="javascript:void(0);" class="weui-footer__link"
                  >校圆通</a
                >
              </p>
              <p class="weui-footer__text">
                Copyright &copy; 2017-{{ year }} aixyt.com
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import weui from "weui.js";
import axios from "axios";
import config from "../../config/config.js";
import moment from "moment";

export default {
  data() {
    return {
      encodeToken: null,
      token: null,
      isEditing: true,
      editMotto: true,
      circle: {
        pics: [],
      },
      uploadCount: 0,
      uploadList: [],
      year: moment().format("YYYY"),
    };
  },
  created() {
    this.encodeToken = this.$route.params.token;
    this.token = decodeURIComponent(this.encodeToken);
    axios.defaults.headers["Authorization"] = "Bearer " + this.token;

    if (
      this.$store.state.User.userInfo &&
      this.$store.state.User.userInfo.motto
    ) {
      this.circle.motto = this.$store.state.User.userInfo.motto;
      if (this.circle.motto) {
        this.editMotto = false;
      }
    }
  },
  methods: {
    goback() {
      this.$router.back(-1);
    },
    edit() {
      this.editMotto = true;
    },
    index() {
      this.$router.push("/circleDiscovery/" + this.encodeToken);
    },
    save() {
      if (!this.circle.motto || this.circle.motto.length < 2) {
        weui.alert("座右铭长度不能小于2");
        return;
      } else if (!this.circle.word || this.circle.word.length < 2) {
        weui.alert("留言长度不能小于2");
        return;
      } else {
        axios
          .post("/api/circle/jyadd", this.circle)
          .then((res) => {
            if (res.data.success) {
              this.isEditing = false;
              this.$store.commit("User/updateMotto", this.circle.motto);
            } else {
              weui.alert("留言失败");
            }
          })
          .catch((err) => {
            weui.alert("留言失败");
          });
      }
    },
  },
  mounted() {
    let that = this;
    /* 生活照自动上传 */
    weui.uploader("#uploader", {
      url: "/api/upload/uploadFile",
      auto: true,
      type: "file",
      fileVal: "fileVal",
      compress: {
        width: 1600,
        height: 1600,
        quality: 0.8,
      },
      onBeforeQueued: function (files) {
        if (
          ["image/jpg", "image/jpeg", "image/png", "image/gif"].indexOf(
            this.type
          ) < 0
        ) {
          weui.alert("请上传正确格式的图片（jpg/png/gif）");
          return false;
        }
        if (this.size > 4 * 1024 * 1024) {
          weui.alert("请上传不超过4M的图片");
          return false;
        }
        if (files.length > 9) {
          // 防止一下子选中过多文件
          weui.alert("最多只能上传9张图片");
          return false;
        }
        if (that.uploadCount + 1 > 9) {
          weui.alert("最多只能上传9张图片");
          return false;
        }

        that.uploadCount++;
      },
      onQueued: function () {
        that.uploadList.push(this);
      },
      onBeforeSend: function (data, headers) {
        headers["Authorization"] = "Bearer " + that.token;
      },
      onProgress: function (procent) {},
      onSuccess: function (ret) {
        let picUrl = `${config.xytPreUrl}/sign/${ret.data.dateFolder}/${ret.data.destFileName}`;
        that.circle.pics.push(picUrl);
      },
      onError: function (err) {
        console.log(err);
      },
    });

    // 图片点击
    document
      .querySelector("#uploaderFiles")
      .addEventListener("click", function (e) {
        var target = e.target;

        while (!target.classList.contains("weui-uploader__file") && target) {
          target = target.parentNode;
        }
        if (!target) return;

        var url = target.getAttribute("style") || "";
        var id = target.getAttribute("data-id");

        if (url) {
          url = url.match(/url\((.*?)\)/)[1].replace(/"/g, "");
        }
        var gallery = weui.gallery(url, {
          className: "custom-name",
          onDelete: function () {
            weui.confirm("确定删除该图片？", function () {
              that.uploadCount--;
              (function () {
                for (var i = 0, len = that.uploadList.length; i < len; ++i) {
                  var file = that.uploadList[i];
                  if (id && file._id && file._id == id) {
                    if (file.id) {
                      file.stop();
                    }
                    that.uploadList.splice(i, 1);

                    // 删除pics数据
                    for (let j = 0; j < that.circle.pics.length; j++) {
                      if (file.url == that.circle.pics[j].blobUrl) {
                        that.circle.pics.splice(j, 1);
                        return;
                      }
                    }
                  }
                }
              })();
              target.remove();
              gallery.hide();
            });
          },
        });
      });
  },
};
</script>

<style scoped>
.weui-cells_form .weui-cell__ft {
  font-size: 17px;
}
.weui-btn_blue {
  background-color: #1296db;
}
.title {
  margin-top: 10px;
  text-align: center;
  display: flex;
  justify-content: center;
  align-items: center;
  padding-bottom: 10px;
  border-bottom: 1px solid #1296db;
  position: relative;
}
.title i {
  position: absolute;
  left: 10px;
  font-size: 22px;
  color: #1296db;
}
.title img {
  width: 18px;
  height: 18px;
  padding: 2px;
  border-radius: 50%;
  border: 2px solid #1296db;
}
.title div {
  font-size: 16px;
  font-weight: bold;
  margin-left: 5px;
  color: #6b6e77;
}
.motto {
  background-color: #1296db;
  color: #ffffff;
  padding: 2px 10px;
  margin-right: 5px;
}
.text-error {
  color: red;
}
.warehousing-footer-item {
  flex: 1;
  font-size: 18px;
  text-align: center;
  background-color: #296aed;
  margin-top: 10px;
  line-height: 50px;
}
.warehousing-footer-item a {
  color: #ffffff;
}
</style>





// WEBPACK FOOTER //
// src/components/operations/CircleJyEdit.vue